<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>
    <h2 langkey="phInvalidDeliveryAddress_Title">

    </h2>
    <div>
      <div class="invalidDeliveryAddress_content" langkey="phInvalidDeliveryAddress_content"></div>
    </div>
    <div class="buttonscontainer">
      <div class="ya-button-container">
        <button mat-flat-button (click)="onChangeLocation()">
          <span langkey="phMenuChangeLocationDialog_ChangeLocation"></span>
        </button>
      </div>
      <div class="ya-button-container">
        <button mat-flat-button (click)="onChangeService()">
          <span langkey="phMenuChangeLocationDialog_ChangeService"></span>
        </button>
      </div>
    </div>
  </div>
</div>